import { useIntl } from "react-intl";
import { DataTableBooleanColumn } from "~components/DataTable/components/DataTableBooleanColumn/DataTableBooleanColumn.tsx";
import type { DataTableColumn } from "~components/DataTable/types/dataTableColumn.ts";
import type { DataTableRow } from "~components/DataTable/types/dataTableRow.ts";
import { RosterTableColumns } from "~pages/Roster/enums/rosterTableColumns.ts";
import type { RosterDataTableRow } from "~pages/Roster/types/rosterDataTableRow.ts";

type Props<TRow extends RosterDataTableRow & DataTableRow> = {
  massEditMode: boolean;
  isRosterEditable: boolean;
  onCaptainToggle: (row: TRow, isCaptain: boolean) => Promise<void>;
};

export const useSharedRosterCaptainColumn = <TRow extends RosterDataTableRow & DataTableRow>({
  massEditMode,
  isRosterEditable,
  onCaptainToggle,
}: Props<TRow>): DataTableColumn<TRow> => {
  const { formatMessage } = useIntl();

  return {
    key: RosterTableColumns.IsCaptain,
    title: formatMessage({ id: "roster.captain" }),
    dataIndex: "isCaptain",
    width: 90,
    render: (value: boolean, row: TRow) => (
      <DataTableBooleanColumn
        value={value}
        isEditMode={massEditMode}
        disabled={row.disabled || !isRosterEditable}
        onSave={(isCaptain) => onCaptainToggle(row, isCaptain)}
      />
    ),
  };
};
